var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.38 0a10.38 10.38 0 110 20.76 10.38 10.38 0 010-20.76zm1.34 16.11v-2.3h-2.6v2.3zm0-4.25V4.97h-2.6v6.9h2.6z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--warning-b5c70cad54f66df940b5610d4b7b5260.svg";
export { SvgIconCircleWarning as Component };